module.exports = __webpack_public_path__ + "img/cloud-4.7b0e218a.svg";